import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CustomRadioComponent } from './custom-radio/custom-radio.component';
import { OptionSelectorComponent } from './option-selector/option-selector.component';
import { RouterModule } from '@angular/router';
import { LocalizedPipe } from '../../pipes/localized.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { AgGridAngular } from 'ag-grid-angular';
import { CustomSpTableComponent } from './custom-sp-table/custom-sp-table.component';
import { ActionsCellRendererComponent } from './actions-cell-renderer/actions-cell-renderer';
import { WarningMessageComponent } from './warning-message/warning-message.component';
import { LocalizedDatePipe } from '../../pipes/localized-date.pipe';
import { EncodeURIComponentPipe } from '../../pipes/encode-uri.pipe';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, RouterModule, TranslateModule, AgGridAngular],
  declarations: [
    HeaderComponent,
    CustomRadioComponent,
    OptionSelectorComponent,
    LocalizedPipe,
    LocalizedDatePipe,
    EncodeURIComponentPipe,
    CustomSpTableComponent,
    ActionsCellRendererComponent,
    WarningMessageComponent,
  ],
  exports: [
    HeaderComponent,
    CustomRadioComponent,
    OptionSelectorComponent,
    LocalizedPipe,
    EncodeURIComponentPipe,
    LocalizedDatePipe,
    CustomSpTableComponent,
    ActionsCellRendererComponent,
    WarningMessageComponent,
  ],
})
export class SharedModule {}
